import moment from 'moment'
import get from 'lodash/get'
import config from '@conf'

const STATES = {
  Open: 1,
  Closed: 2,
  Cancelled: 4
}

export class SaleRecord {
  constructor (record) {
    this._record = record

    this.id = record.id
    this.owner = record.owner_id
    this.baseAsset = record.base_asset
    this.defaultQuoteAsset = record.default_quote_asset
    this.quoteAssets = get(record, 'quote_assets.quote_assets') || []
    this.baseHardCap = record.base_hard_cap
    this.startTime = record.start_time
    this.endTime = record.end_time
    this.softCap = parseFloat(record.soft_cap)
    this.hardCap = parseFloat(record.hard_cap)
    this.currentCap = parseFloat(record.current_cap)
    this.finishCap = this.hardCap - this.currentCap
    this.currentCapProc = this.currentCap * 100 / this.hardCap
    this.status = get(record, 'state.name')
    this.statistics = record.statistics
    this.investors = get(record, 'statistics.investors')
    this.averageInvestment = get(record, 'statistics.average_amount')
    this.details = record.details
    this.description = ''
    this.secondsToEnd = moment(this.endTime).diff(moment(), 'seconds')
    this.daysCampaignDuration = moment(this.endTime).diff(moment(this.startTime), 'days')
    this.name = get(record, 'details.name')
    this.internal_type = get(record, 'details.internal_type')
    this.descriptionID = get(record, 'details.description')
    this.shortDescription = get(record, 'details.short_description')
    this.youtube_video_id = get(record, 'details.youtube_video_id')
    this.video_description = get(record, 'details.video_description')
    this.investorIncome = get(record, 'details.investor_income')
    this.logo = get(record, 'details.logo')
    this.description = get(record, 'details.description')
    this.minTerm = get(record, 'details.min_term')
    this.term = get(record, 'details.term')
    this.financial_frequency = get(record, 'details.financial_frequency')
    this.loan_term = get(record, 'details.loan_term')
    this.paymentsFrequency = get(record, 'details.payments_frequency')
    this.annualPercentage = get(record, 'details.annual_percentage')
    this.profitability_from = get(record, 'details.profitability_from')
    this.profitability_to = get(record, 'details.profitability_to')
    this.daysToEnd = moment(this.endTime).diff(moment(), 'days')
  }

  get quoteAssetCodes () {
    return this.quoteAssets.map(asset => asset.asset)
  }

  get quoteAssetPrices () {
    return this.quoteAssets.reduce((prices, asset) => { prices[asset.asset] = asset.price; return prices }, {})
  }

  get currentCaps () {
    return this.quoteAssets.reduce((caps, asset) => { caps[asset.asset] = asset.current_cap; return caps }, {})
  }

  get totalCurrentCaps () {
    return this.quoteAssets.reduce((caps, asset) => { caps[asset.asset] = asset.total_current_cap; return caps }, {})
  }

  get hardCaps () {
    return this.quoteAssets.reduce((caps, asset) => { caps[asset.asset] = asset.hard_cap; return caps }, {})
  }

  get acceptsBTC () {
    return this.quoteAssetCodes.indexOf('BTC') !== -1
  }

  get acceptsETH () {
    return this.quoteAssetCodes.indexOf('ETH') !== -1
  }

  get daysToGo () {
    const now = moment()
    const ends = moment(this.endTime)
    if (ends.isBefore(now)) return -1
    return ends.diff(now, 'days')
  }

  get hardCapProgress () {
    return Math.round(this.currentCap / this.hardCap / 100) * 10000
  }

  get softCapProgress () {
    return Math.round(this.currentCap / this.softCap / 100) * 10000
  }

  get image () {
    const key = this._record.details.logo.key
    return `${config.FILE_STORAGE}/${key}`
  }

  get isOpened () {
    return this._record.state.value === STATES.Open
  }

  get isClosed () {
    return this._record.state.value === STATES.Closed
  }

  get isCanceled () {
    return this._record.state.value === STATES.Cancelled
  }

  get state () {
    return this._record.state.name
  }

  get isUpcoming () {
    const now = moment()
    return moment(this.startTime).isAfter(now)
  }

  get startsIn () {
    const now = moment().startOf('day')
    const starts = moment(this.startTime)
    return starts.diff(now, 'days')
  }
}



// WEBPACK FOOTER //
// ./src/js/records/sale.record.js